<p>help-google-analytics-identity works!</p>
